import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import './globals.css';
import { setupResourceHints } from './utils/resourceHints';
import { initializePerformanceOptimizations } from './utils/performanceOptimizer';
import { captureCampaignFromUrl, capturePushClickFromUrl } from './utils/campaignCapture';

// 캠페인 링크(?utm_campaign=…) 착지 기록 — 라우터가 /auth 로 보내며 쿼리를 지우기 전에 먼저 보관 (2026-09-17)
captureCampaignFromUrl();
// 푸시 누름(?pushclick=1&pc=…) 기록도 같은 시점에 보관 (2026-10-22)
capturePushClickFromUrl();

// 성능 최적화 초기화
setupResourceHints();
initializePerformanceOptimizations();

// 배포 직후 옛 세션이 사라진 해시 청크를 프리로드하다 실패하는 케이스 —
// Vite가 쏘는 preloadError를 잡아 1회 자동 새로고침으로 새 청크 맵을 받는다.
window.addEventListener('vite:preloadError', (event) => {
    event.preventDefault();
    try {
        if (sessionStorage.getItem('sdl_chunk_reload_once') === '1') return;
        sessionStorage.setItem('sdl_chunk_reload_once', '1');
    } catch { /* 프라이빗 모드 등 — 그냥 진행 */ }
    window.location.reload();
});

// 30초 안정 구동 시 1회-새로고침 가드 해제 — 다음 배포에서도 자동 복구가 다시 작동하게
window.setTimeout(() => {
    try { sessionStorage.removeItem('sdl_chunk_reload_once'); } catch { /* 무시 */ }
}, 30000);

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <AppErrorBoundary>
            <App />
        </AppErrorBoundary>
    </React.StrictMode>,
); 